module.exports = __webpack_public_path__ + "img/Weapon_241.490bd28a.png";